import React, {useState, useEffect} from "react";
import styles from "components/dialog-layout/index.module.scss";
import iconClose from "assets/icon_xx.svg";
import className from "classnames/bind";
import clsx from "classnames";

const cx = className.bind(styles);

const DialogLayout = ({isShow = false, withClose, children, onDismiss, className}) => {
  const [show, setShow] = useState(isShow);
  const handleClose = () => {
    setShow(false);
    onDismiss();
  };

  useEffect(() => {
    setShow(isShow);
  }, [isShow]);

  const dialogLayoutClasses = cx({
    "dialog-layout": true,
    show: show,
    hide: !show,
  });

  return (
    <div className={clsx(dialogLayoutClasses, className)}>
      <div className={clsx(styles.content, 'dialog-content')}>
        {withClose ? <img className={styles.close} src={iconClose} onClick={handleClose} alt="close" /> : <></>}
        {children}
      </div>
    </div>
  );
};

export default DialogLayout;
